import React, {useEffect} from 'react';
import { 
  Box, 
  Typography, 
  IconButton, 
  useTheme, 
  useMediaQuery 
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import TableHeadingTypography from '../../../commonComponent/TableHeadingTypography';
import { useModal } from '../../../../layouts/MainLayout';
import { useSelector } from 'react-redux';
import { pt } from 'date-fns/locale';
import { useTranslation } from 'react-i18next';

const ReusableModal = ({
  open,
  onClose,
  title = '',
  description = '',
  children,
  style = {},
  className='',
   headerPadding = { px: 1, pb: '5px' ,pt:0},
     headerBg,
     showCloseIcon = true, 
   contentPadding = { px: 3, pt: 1, pb: 2 },
   closeIconColor = '#ffffffff',
   customWidth = null,
     showBackdrop="rgba(0, 0, 0, 0.1)",
     showCloseButton="flex"

   
}) => {
  const { t } = useTranslation();
  const theme = useTheme();
  const isDark = theme.palette.mode === 'dark';
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
  const isTablet = useMediaQuery(theme.breakpoints.between('sm', 'md'));
    const customColors = useSelector((state) => state.theme.customColors);

  const { setModalState } = useModal();

    useEffect(() => {
    if (open) {
      setModalState({ open: true, component: null, props: {} });
      document.body.style.overflow = 'hidden';
    } else {
      setModalState({ open: false, component: null, props: {} });
      document.body.style.overflow = 'auto';
    }

    return () => {
      document.body.style.overflow = 'auto';
    };
  }, [open, setModalState]);

  if (!open) return null;
  const defaultWidth = {
    xs: '95%',
    sm: '90%',
    md: '80%',
    lg: '50%',
    xl: '35%',
  };
   const finalWidth = customWidth || defaultWidth;
  const defaultStyle = {
    position: 'relative',
  width: finalWidth,
    bgcolor: (theme) => theme.palette.background.bgwhite,
    borderRadius: '5px',
    boxShadow: 'none',
    zIndex: 1000,
    marginLeft: 'auto',
    marginRight: 'auto',
    marginTop: 'calc((100vh - 130px) / 8)',
    marginBottom: '10px',
    // border: `1px solid ${theme.palette.custom.borderColor}`,
    // border: "5px solid",
    border: theme.palette.mode === 'dark'
     ? '5px solid'
     : '5px solid',
  borderColor:
  theme.palette.mode === 'dark'
    ? 'rgba(115, 102, 255, .2)'
    : customColors?.activeButton || theme.palette.background.bgpurple
  };

  const mergedStyle = { ...defaultStyle, ...style };
  // if (!open) return null;
  return (
    <Box
    className="voilet-scroll-container"
      sx={{
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        height: '100%',
        width: '100%',
        bgcolor: showBackdrop,
        zIndex: 1298,
        overflowY: 'auto',
      }}
    >
      <Box
        tabIndex={0}
        className={`${className} voilet-scroll-container`}
        sx={{
          ...mergedStyle,
          '&:focus-visible': {
            outline: 'none',
          },
        }}
      >
        <Box {...headerPadding}
          sx={{
    background: 
      theme.palette.mode === 'dark'
    ? 'rgba(115, 102, 255, .2)'
    : customColors && customColors.activeButton || theme.palette.background.bgpurple,
    color:'#fff',
    position:'relative'
  }}
        //  sx={{background: isDark ? '#111417' : '#f2f4f8'}}
         >
          {showCloseIcon && (
          <IconButton className='voilet-btn'
            aria-label={t('components.close')}
            onClick={onClose}
            sx={{
              position: 'absolute',
              transform: 'translateY(-50%)',
              right: '0px',
              top: '50%',
              color: closeIconColor,
              fontSize:"16px",
              bgcolor: 'none',
              // bgcolor: '#f1eded',
              height:"24px",
              width:"24px",
              display:showCloseButton,
              '&:hover': {
                bgcolor: 'none',
                color: closeIconColor,
                height:"24px",
                width:"24px"
              },
            }}
          >
            <i class="fa-sharp fa-light fa-xmark"></i>
          </IconButton>
          )}
          {/* Modal Title */}
          {title && (
            <TableHeadingTypography
            sx={{color:'#fff'}}
              id="reusable-modal-title"
              className="modalheading"
              text={title}
              variant="h6"
            />
          )}
          {description && (
            <Typography id="reusable-modal-description"
            >
              {description}
            </Typography>
          )}
        </Box>
        <Box  {...contentPadding} sx={{
          borderTopLeftRadius: '24px',
          borderTopRightRadius: '24px',
        }}>
          {children}
        </Box>
      </Box>
    </Box>
  );
};

export default ReusableModal;